// extracted by mini-css-extract-plugin
export default {"background":"styles_background__HZXJq","icon":"styles_icon__1R1Rt"};